import { useMutation, useQuery } from '@tanstack/react-query';
import { subTempleService } from './sub-temple.service';
import { useQueryClient } from '@tanstack/react-query';

export const useGetSubTemples = (
  templeId = undefined,
  page = 1,
  limit = 10
) => {
  return useQuery({
    queryKey: ['subTempleService.getAllSubTemples', templeId, page, limit],
    queryFn: () => subTempleService.getAllSubTemples(templeId, page, limit),
  });
};

export const useCreateSubTemple = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ templeId, shortName, name }) =>
      subTempleService.createSubTemple(templeId, shortName, name),
    onSuccess: () => {
      queryClient.invalidateQueries('subTempleService.getAllSubTemples');
    },
  });
};

export const useUpdateSubTemple = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ templeId, subTempleId, shortName, name }) =>
      subTempleService.updateSubTemple(templeId, subTempleId, shortName, name),
    onSuccess: () => {
      queryClient.invalidateQueries('subTempleService.getAllSubTemples');
    },
  });
};

export const useDeleteSubTemple = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ templeId, subTempleId }) =>
      subTempleService.deleteSubTemple(templeId, subTempleId),
    onSuccess: () => {
      queryClient.invalidateQueries('subTempleService.getAllSubTemples');
    },
  });
};
